class WidgetTitle {
  constructor(private readonly _value: string = "") {
  }

  get value() {
    return this._value;
  }
}

export default WidgetTitle;
